(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5696],{

/***/ 9073:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/policy/acceptable-use-policy",
      function () {
        return __webpack_require__(42305);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ getEntries; }
/* harmony export */ });
/* unused harmony export getImage */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _contentful_rich_text_html_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22135);
/* eslint-disable @typescript-eslint/no-explicit-any */ // (we maybe want to look into getting the types from contentful at some point)


// eslint-disable-next-line @typescript-eslint/no-var-requires
var contentful = __webpack_require__(83010);
var _obj;
var clients = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "live", contentful.createClient({
    space: "wke7mf1na8hm",
    accessToken: "gQP_zw0MxtFM6Ovve8c44pZrFZZtBN9JRZV7BEsJJBs"
})), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, "preview", contentful.createClient({
    space: "wke7mf1na8hm",
    accessToken: "wKd5svWZpmXWnmp2-2E3lJ4PCSspUxXBwvwJC4CY058",
    host: "preview.contentful.com"
})), _obj);
var schema = "https";
var getImage = function(image, isPreview) {
    var client = clients[isPreview ? "preview" : "live"];
    return client.getAsset(image).then(mapImage).catch(function(err) {
        return console.error(err);
    });
};
var mapImage = function(image) {
    return {
        title: image.fields.title,
        url: schema + ":" + image.fields.file.url,
        description: image.fields.description
    };
};
var mapSection = function(item) {
    var image = item.fields.image ? mapImage(item.fields.image) : undefined;
    var images = item.fields.images ? item.fields.images.map(mapImage) : undefined;
    var trustedBy = item.fields.trustedBy ? item.fields.trustedBy.fields.trustedBy.map(function(item) {
        var trustedByItem = {
            title: item.fields.title,
            image: {
                title: item.fields.image.fields.title,
                url: schema + ":" + item.fields.image.fields.file.url
            }
        };
        return trustedByItem;
    }) : undefined;
    var collections = item.fields.collections ? item.fields.collections.fields.collections.map(function(item) {
        var collectionItem = {
            title: item.fields.title,
            image: {
                title: item.fields.image.fields.title,
                url: schema + ":" + item.fields.image.fields.file.url
            }
        };
        return collectionItem;
    }) : undefined;
    var subSections = item.fields.subSections ? item.fields.subSections.map(mapSection) : undefined;
    return {
        title: item.fields.title,
        quote: item.fields.quote,
        richQuote: item.fields.richQuote ? (0,_contentful_rich_text_html_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToHtmlString */ .S)(item.fields.richQuote) : "",
        image: image,
        images: images,
        trustedBy: trustedBy,
        collections: collections,
        subSections: subSections
    };
};
var getEntries = function(page, isPreview) {
    var client = clients[isPreview ? "preview" : "live"];
    return client.getEntries({
        content_type: "page",
        "fields.slug": page,
        include: 10
    }).then(function(entry) {
        var ref;
        var faq = entry.items[0].fields.faqSection ? entry.items[0].fields.faqSection.fields.questionsAndAnswers.map(function(item) {
            var test = {
                question: item.fields.question,
                richAnswer: (0,_contentful_rich_text_html_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToHtmlString */ .S)(item.fields.richAnswer)
            };
            return test;
        }) : undefined;
        var howItWorks = entry.items[0].fields.howItWorksSection ? entry.items[0].fields.howItWorksSection.fields.howItWorksList.map(function(item) {
            var test = {
                title: item.fields.title,
                quote: (0,_contentful_rich_text_html_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToHtmlString */ .S)(item.fields.quote),
                icon: item.fields.icon.fields.icon
            };
            return test;
        }) : undefined;
        var sessions = (ref = entry.items[0].fields.sections) === null || ref === void 0 ? void 0 : ref.map(mapSection);
        return {
            sessions: sessions,
            faq: faq,
            howItWorks: howItWorks
        };
    }).catch(function(err) {
        return console.error(err);
    });
};


/***/ }),

/***/ 25567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ Portal_PortalLayout; },
  "Z": function() { return /* binding */ Portal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Grid/FullPageGrid.mjs + 4 modules
var FullPageGrid = __webpack_require__(61827);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/theme.mjs
var theme = __webpack_require__(67717);
// EXTERNAL MODULE: ./providers/messageprovider/index.tsx
var messageprovider = __webpack_require__(17581);
// EXTERNAL MODULE: ./providers/environmentprovider/index.tsx
var environmentprovider = __webpack_require__(41319);
// EXTERNAL MODULE: ./providers/activetrackprovider/index.tsx
var activetrackprovider = __webpack_require__(59451);
// EXTERNAL MODULE: ./providers/playerqueueprovider/index.tsx
var playerqueueprovider = __webpack_require__(43165);
// EXTERNAL MODULE: ./providers/loadingprovider/index.tsx
var loadingprovider = __webpack_require__(79342);
// EXTERNAL MODULE: ./node_modules/react-dnd-html5-backend/dist/esm/index.js + 12 modules
var esm = __webpack_require__(42043);
// EXTERNAL MODULE: ./node_modules/react-dnd/dist/esm/core/DndProvider.js + 34 modules
var DndProvider = __webpack_require__(78671);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(47411);
// EXTERNAL MODULE: ./components/navigation/Navigation.tsx + 7 modules
var Navigation = __webpack_require__(20865);
// EXTERNAL MODULE: ./components/toast/Toast.tsx
var Toast = __webpack_require__(70471);
// EXTERNAL MODULE: ./components/audio/PlayerBar.tsx + 5 modules
var PlayerBar = __webpack_require__(5472);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
;// CONCATENATED MODULE: ./components/layout/portal/Layout.tsx







var PortalLayout = function(param) {
    var children = param.children;
    var ref = (0,next_auth_react.useSession)(), session = ref.data;
    (0,react.useEffect)(function() {
        if ((session === null || session === void 0 ? void 0 : session.error) === "RefreshAccessTokenError") {
            (0,next_auth_react.signIn)("keycloak") // Force sign in to hopefully resolve error
            ;
        }
    }, [
        session
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* Navigation */.W_, {
                isAuthenticated: session != null,
                app: "DevPortal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* Toast */.F, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayerBar/* PlayerBar */.e, {
                app: "DevPortal"
            })
        ]
    });
};

// EXTERNAL MODULE: ./providers/pagemodeprovider/index.tsx
var pagemodeprovider = __webpack_require__(69329);
// EXTERNAL MODULE: ./providers/contentfulpreviewprovider/index.tsx
var contentfulpreviewprovider = __webpack_require__(57642);
// EXTERNAL MODULE: ./hooks/hooks.ts
var hooks = __webpack_require__(22699);
// EXTERNAL MODULE: ./utils/tracking.ts + 1 modules
var tracking = __webpack_require__(19327);
;// CONCATENATED MODULE: ./layouts/Portal.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 8rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    .portal-page-grid {\n        width: 100%;\n    }\n\n    @media only screen and (max-width: ",
        ") {\n        .portal-page-grid {\n            padding-right: 0;\n            padding-left: 0.5rem;\n        }\n    }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var StyledCol = (0,styled_components_browser_esm/* default */.ZP)(FullPageGrid/* FullPageGrid.Col */.gc.Col).withConfig({
    componentId: "sc-bdcb6373-0"
})(_templateObject());
var StyledGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bdcb6373-1"
})(_templateObject1(), hooks/* smallScreenWidth */.IW + "px");
var Portal_PortalLayout = function(param) {
    var children = param.children;
    (0,react.useEffect)(function() {
        (0,tracking/* pageView */.t)("Portal");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(theme/* ThemeProvider */.f6, {
        theme: theme/* THEMES.DARK */.yU.DARK,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(messageprovider/* default */.Z, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contentfulpreviewprovider/* default */.Z, {
                initialPreview: false,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(environmentprovider/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(activetrackprovider/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(playerqueueprovider/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loadingprovider/* default */.Z, {
                                initialLoading: false,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(pagemodeprovider/* default */.Z, {
                                    initialMode: "View",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PortalLayout, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledGrid, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageGrid/* FullPageGrid */.gc, {
                                                className: "portal-page-grid",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCol, {
                                                    size: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DndProvider/* DndProvider */.W, {
                                                        backend: esm/* HTML5Backend */.PD,
                                                        children: children
                                                    })
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Portal = (Portal_PortalLayout);


/***/ }),

/***/ 42305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ acceptable_use_policy; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./hooks/hooks.ts
var hooks = __webpack_require__(22699);
// EXTERNAL MODULE: ./utils/methods.ts
var methods = __webpack_require__(84918);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 9 modules
var styled_components_browser_esm = __webpack_require__(47411);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Typography/Typography.mjs
var Typography = __webpack_require__(73550);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/constants.mjs
var constants = __webpack_require__(55287);
// EXTERNAL MODULE: ./api/contentful.ts
var contentful = __webpack_require__(65347);
// EXTERNAL MODULE: ./node_modules/@epidemicsound/design-system/dist/components/Spinner/Spinner.mjs
var Spinner = __webpack_require__(34339);
// EXTERNAL MODULE: ./node_modules/html-react-parser/esm/index.mjs
var esm = __webpack_require__(47311);
;// CONCATENATED MODULE: ./components/policy/AcceptableUsePolicyPage.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








var Title = Typography/* Title */.Dx;
var AUPContainer = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-326e0715-0"
})(_templateObject(), constants/* COLORS.BLACK */.DM.BLACK);
var AcceptableUsePolicyPage = function(param) {
    var _isPreview = param.isPreview, isPreview = _isPreview === void 0 ? false : _isPreview;
    var setPreview = (0,hooks/* useContentfulPreview */.NS)().setPreview;
    var ref = (0,hooks/* useLoading */.r$)(), isLoading = ref.isLoading, setLoading = ref.setLoading;
    var ref1 = (0,react.useState)(), section = ref1[0], setSection = ref1[1];
    (0,react.useEffect)(function() {
        setPreview(isPreview);
        setLoading(true);
        (0,contentful/* getEntries */.C)("landing-page", isPreview).then(function(page) {
            setSection(page.sessions[3]);
        }).finally(function() {
            return setLoading(false);
        });
    }, [
        isPreview
    ]);
    var richQuote = section === null || section === void 0 ? void 0 : section.richQuote;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AUPContainer, {
        children: isLoading === false && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: section === null || section === void 0 ? void 0 : section.title
                }),
                richQuote ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: (0,esm/* default */.ZP)(richQuote)
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "Something went wrong, no data to find."
                })
            ]
        }) || /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* Spinner */.$, {
            size: 32
        })
    });
};

// EXTERNAL MODULE: ./layouts/Portal.tsx + 1 modules
var Portal = __webpack_require__(25567);
;// CONCATENATED MODULE: ./pages/policy/acceptable-use-policy/index.tsx






var AcceptableUsePolicy = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,hooks/* usePortal */.vI)(), 2), router = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AcceptableUsePolicyPage, {
        isPreview: (0,methods/* queryParamToBoolean */.Xl)(router.query.preview, false)
    });
};
AcceptableUsePolicy.getLayout = function(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Portal/* default */.Z, {
        children: page
    });
};
/* harmony default export */ var acceptable_use_policy = (AcceptableUsePolicy);


/***/ }),

/***/ 38349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d8": function() { return /* binding */ setCookie; },
/* harmony export */   "ej": function() { return /* binding */ getCookie; },
/* harmony export */   "h2": function() { return /* binding */ hasCookie; },
/* harmony export */   "nJ": function() { return /* binding */ removeCookie; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

var getCookie = function(name) {
    return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(name);
};
var hasCookie = function(name) {
    return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get(name) !== undefined;
};
var setCookie = function(name, value, expires, path, domain) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set(name, value, {
        expires: expires,
        path: path,
        domain: domain
    });
};
var removeCookie = function(name, path, domain) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove(name, {
        path: path,
        domain: domain
    });
};


/***/ }),

/***/ 19327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ pageView; },
  "k": function() { return /* binding */ trackButtonClick; }
});

// EXTERNAL MODULE: ./node_modules/@snowplow/browser-tracker/dist/index.module.js + 2 modules
var index_module = __webpack_require__(41933);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(57632);
// EXTERNAL MODULE: ./utils/cookie.ts
var cookie = __webpack_require__(38349);
;// CONCATENATED MODULE: ./utils/snowplow.ts


var CONSTANTS = {
    // Client session specific constants
    SESSION_ID_KEY: "session_id",
    SESSION_COOKIE_NAME: "client_session_id",
    // Snowplow specific constants
    DEVELOPERS_PORTAL_CTX: "PAPI_DEVELOPERS_PORTAL",
    DEVELOPERS_PORTAL_TRACKER_NAME: "sp-developers-portal",
    SNOWPLOW_TRACKER_ID: "sp-developers-portal",
    SNOWPLOW_COLLECTER_URL: "t.epidemicsound.com" || 0,
    SNOWPLOW_HOST: "t.epidemicsound.com" || 0,
    SNOWPLOW_POST_PATH: "/com.snowplowanalytics.snowplow/tp2" || 0,
    SNOWPLOW_APP_ID: "partner-content-ui"
};
// Entities (context) in snowplow
var ENTITIES = {
    CONTEXT: "iglu:com.epidemicsound/context/jsonschema/1-0-38",
    WEB_SESSION: "iglu:com.epidemicsound/web_session/jsonschema/2-0-0",
    EVENT_UUID: "iglu:com.epidemicsound/event_uuid/jsonschema/1-0-0"
};
var SCHEMAS = {
    PAGE_VIEW: "iglu:com.epidemicsound/pageview/jsonschema/4-0-2",
    CTA_CLICKED: "iglu:com.epidemicsound/cta_clicked/jsonschema/3-0-0"
};
function pageViewSchemaData(landingPage) {
    return {
        schema: SCHEMAS.PAGE_VIEW,
        data: {
            landing_page: landingPage
        }
    };
}
function addContextEntity(context) {
    return {
        schema: ENTITIES.CONTEXT,
        data: {
            context: context ? context : CONSTANTS.DEVELOPERS_PORTAL_CTX
        }
    };
}
function addWebSessionEntity() {
    return {
        schema: ENTITIES.WEB_SESSION,
        data: {
            client_session_id: getClientSessionId()
        }
    };
}
function addEventUUIDEntity() {
    var event_uuid = {
        schema: ENTITIES.EVENT_UUID,
        data: {
            event_uuid: (0,v4/* default */.Z)()
        }
    };
    return event_uuid;
}
function getSnowplowDomainUid() {
    var cookieName = "_sp_";
    var matcher = new RegExp("".concat(cookieName, "id\\.[a-f0-9]+=([^;]+);?"));
    var match = document.cookie.match(matcher);
    if (match && match[1]) {
        var split = match[1].split(".");
        return {
            domain_userid: split[0],
            domain_sessionidx: split[2],
            domain_sessionid: split[5]
        };
    }
    return false;
}
function getClientSessionId() {
    var spTrackingInfo = getSnowplowDomainUid();
    var host = window.location.hostname;
    var domainParts = host.split(".");
    domainParts.shift();
    var domain = domainParts.join(".");
    if (!document.cookie.includes(CONSTANTS.SESSION_COOKIE_NAME)) {
        // If no session_id and no cookies, use snowplow session_id
        if (spTrackingInfo && spTrackingInfo.domain_sessionid) {
            (0,cookie/* setCookie */.d8)(CONSTANTS.SESSION_COOKIE_NAME, spTrackingInfo.domain_sessionid, 730, domain);
        } else {
            var generatedSessionUUID = (0,v4/* default */.Z)();
            (0,cookie/* setCookie */.d8)(CONSTANTS.SESSION_COOKIE_NAME, generatedSessionUUID, 730, domain);
        }
    }
    return (0,cookie/* getCookie */.ej)(CONSTANTS.SESSION_COOKIE_NAME);
}


;// CONCATENATED MODULE: ./utils/tracking.ts


// Instantiate a new Tracker Object (needed only once)
(0,index_module/* newTracker */.VZ)(CONSTANTS.SNOWPLOW_TRACKER_ID, CONSTANTS.SNOWPLOW_COLLECTER_URL, {
    appId: CONSTANTS.SNOWPLOW_APP_ID,
    postPath: CONSTANTS.SNOWPLOW_POST_PATH,
    discoverRootDomain: true,
    cookieSameSite: "Lax",
    // If DNT header is present and enabled, tracker will not send tracking requests
    respectDoNotTrack: true,
    contexts: {
        webPage: true,
        session: true
    }
});
var pageView = function(title) {
    var pageViewEvent = {
        title: title,
        context: [
            pageViewSchemaData(window.location.pathname),
            addEventUUIDEntity(),
            addWebSessionEntity(), 
        ]
    };
    (0,index_module/* trackPageView */.Z0)(pageViewEvent);
};
var trackButtonClick = function(action, context) {
    (0,index_module/* trackSelfDescribingEvent */.i$)({
        event: {
            schema: SCHEMAS.CTA_CLICKED,
            data: {
                action: action
            }
        },
        context: [
            addEventUUIDEntity(),
            addWebSessionEntity(),
            addContextEntity(context), 
        ]
    }, [
        CONSTANTS.DEVELOPERS_PORTAL_TRACKER_NAME,
        CONSTANTS.DEVELOPERS_PORTAL_CTX, 
    ]);
};



/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9872,6713,9829,6993,1723,1876,4742,704,2699,5472,3933,9774,2888,179], function() { return __webpack_exec__(9073); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);